import http from "../../http";
import DoubtInterface from "./doubt_interface";
import {Doubt} from "../../../../domain/entities/doubt";
import {wrapErrorHandler} from "../../utils/wrap_error_handler";

class DoubtRepository implements DoubtInterface {
  async create(doubt: Doubt, courseID: number, contentID: number): Promise<number> {
    return wrapErrorHandler<number>(async () => {
      const response = await http.post(`/api/decola/courses/${courseID}/contents/${contentID}/questions`, doubt);
      return response.data.id;
    });
  }

  async list(courseID: number, contentID: number): Promise<Doubt[]> {
    return wrapErrorHandler<Doubt[]>(async () => {
      const response = await http.get(`/api/decola/courses/${courseID}/contents/${contentID}/questions`);
      return response.data;
    });
  }
}

export default new DoubtRepository() as DoubtInterface;
